import PropTypes from 'prop-types';
import React from 'react';

export default function ToastIcon({ color, isInfo, className }) {
  return (
    <svg className={className} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <circle fill={color} cx="8" cy="8" r="8" />
        <path
          d={
            !isInfo
              ? 'M8 9.75A1.13 1.13 0 1 1 8 12a1.13 1.13 0 0 1 0-2.25zM8.5 4c.28 0 .5.22.5.5v3.75a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V4.5c0-.28.22-.5.5-.5h1z'
              : 'M8.5 7.25c.28 0 .5.22.5.5v3.75a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V7.75c0-.28.22-.5.5-.5h1zM8 4a1.13 1.13 0 1 1 0 2.25A1.13 1.13 0 0 1 8 4z'
          }
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

ToastIcon.propTypes = {
  color: PropTypes.string,
  isInfo: PropTypes.bool,
  className: PropTypes.string,
};

ToastIcon.defaultProps = {
  color: '#337AB7',
  isInfo: false,
  className: '',
};
